<ng-container [ngSwitch]="column.filterType">
  <app-grid-percentage-filter-menu
    *ngSwitchCase="'percentage'"
    [column]="gridColumn"
    [filter]="filter"
    [filterService]="filterService"
  ></app-grid-percentage-filter-menu>
  <kendo-grid-numeric-filter-menu
    *ngSwitchCase="'numeric'"
    [extra]="false"
    [column]="gridColumn"
    [filter]="filter"
    [filterService]="filterService"
  >
  <kendo-filter-eq-operator></kendo-filter-eq-operator>
  <kendo-filter-lt-operator></kendo-filter-lt-operator>
  <kendo-filter-gt-operator></kendo-filter-gt-operator>
</kendo-grid-numeric-filter-menu>
  <kendo-grid-string-filter-menu
    *ngSwitchCase="'text'"
    [extra]="false"
    [column]="gridColumn"
    [filter]="filter"
    [filterService]="filterService"
  >
      <kendo-filter-contains-operator></kendo-filter-contains-operator>
</kendo-grid-string-filter-menu>
  <kendo-grid-date-filter-menu
    *ngSwitchCase="'date'"
    [extra]="false"
    [column]="gridColumn"
    [filter]="filter"
    [filterService]="filterService"
  >
<kendo-filter-after-eq-operator></kendo-filter-after-eq-operator>
<kendo-filter-before-eq-operator></kendo-filter-before-eq-operator>
</kendo-grid-date-filter-menu>
  <kendo-dropdownlist
    *ngSwitchCase="'boolean'"
    textField="name"
    valueField="value"
    [data]="
      column.filterOptions || [
        { name: 'Yes', value: true },
        { name: 'No', value: false },
      ]
    "
    [value]="booleanValue"
    (selectionChange)="onCustomFilterChange($event)"
  ></kendo-dropdownlist>
  <kendo-multiselect
    *ngSwitchCase="'multiselect'"
    textField="name"
    valueField="value"
    [data]="column.filterOptions || []"
    [value]="multiselectValue"
    [placeholder]="'Select...'"
    (valueChange)="onMultiselectFilterChange($event)"
  ></kendo-multiselect>
  <ng-container *ngSwitchCase="'custom'">
    <ng-container *ngIf="column.filterTemplate">
      <ng-container
        *ngTemplateOutlet="
          column.filterTemplate;
          context: { column: column, filterService: filterService }
        "
      ></ng-container>
    </ng-container>
  </ng-container>
</ng-container>
